import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const normalizeName = (value) => {
  if (value == null || value === "") {
    return "";
  }
  return String(value).trim();
};

const coalesceVendor = (vendor) => vendor ?? {};

export const buildVendorBusinessTradeParts = (vendor) => {
  const safeVendor = coalesceVendor(vendor);
  const businessName = normalizeName(safeVendor.business_name ?? safeVendor.businessName);
  const tradeName = normalizeName(safeVendor.trade_name ?? safeVendor.tradeName);
  return { businessName, tradeName };
};

export const buildVendorBusinessTradeTitle = (vendorId, vendor) => {
  const { businessName, tradeName } = buildVendorBusinessTradeParts(vendor);
  const chunks = [];
  if (businessName) {
    chunks.push(`${businessName}`);
  }
  if (tradeName) {
    chunks.push(`${tradeName}`);
  }
  const label = chunks.length ? chunks.join(" — ") : "N/D";
  return `${vendorId} — ${label}`;
};

const VendorBusinessTradeNames = ({
  vendor,
  layout = "stack",
  className = "",
  emptyFallback = "—",
}) => {
  const { businessName, tradeName } = buildVendorBusinessTradeParts(vendor);

  if (!businessName && !tradeName) {
    return <span className={className}>{emptyFallback}</span>;
  }

  if (layout === "inline") {
    const chunks = [];
    if (businessName) {
      chunks.push(`${businessName}`);
    }
    if (tradeName) {
      chunks.push(`${tradeName}`);
    }
    return (
      <span className={`cm-vendor-business-trade-names is-inline${className ? ` ${className}` : ""}`.trim()}>
        {chunks.join(" — ")}
      </span>
    );
  }

  return (
    <span className={`cm-vendor-business-trade-names is-stack${className ? ` ${className}` : ""}`.trim()}>
      <Typography component="span" className="cm-vendor-name-line">
        <span className="cm-vendor-name-kicker" title="Ragione sociale">RS</span>
        {businessName || emptyFallback}
      </Typography>
      <Typography component="span" className="cm-vendor-name-line">
        <span className="cm-vendor-name-kicker" title="Nome commerciale">NC</span>
        {tradeName || emptyFallback}
      </Typography>
    </span>
  );
};

VendorBusinessTradeNames.propTypes = {
  vendor: PropTypes.object,
  layout: PropTypes.oneOf(["stack", "inline"]),
  className: PropTypes.string,
  emptyFallback: PropTypes.string,
};

export default VendorBusinessTradeNames;
